export default {
  scoreCard: {
    score: "النقاط",
    copyToast: "تم نسخ رمز الخصم."
  },
  infoCard: {
    accountSetting: "إعدادات الحساب",
    deposit: "إيداع",
    withdrawal: "سحب",
    totalAssetsValue: "قيمة الأصول الإجمالية",
    profitOrLossAmount: "إجمالي الربح (الخسارة)"
  },
  referralCard: {
    introduceToFriends: "ادعو أصدقائك",
    inviteGetExcoin: "ادع أصدقائك، واحصل على Excoin",
    referralCode: "رمز الإحالة",
    referralLink: "رابط الإحالة",
    referralCodeCopied: "تم نسخ رمز الإحالة",
    referralLinkCopied: "تم نسخ رابط الإحالة"
  },
  pmCard: {
    tradePerfectMoney: "شراء/بيع Perfect Money",
    perfectMoneyDesc: "في هذا القسم، يمكنك شراء وبيع Perfect Money."
  },
  scoresCard: {
    scoresTitle: "مهرجان Excoino Coolak",
    scoresDescription: "إجمالي نقاطك في مهرجان Excoino Coolak حتى بداية اليوم"
  },
  authorizationCard: {
    authorizationNotCompleted: "لم يتم استكمال التحقق من هويتك",
    completeAuthDesc: "بإكمال التحقق من هويتك، يمكنك إيداع وسحب الريال.",
    completeAuthorization: "أكمل التحقق من الهوية"
  },
  marketBanner: {
    newLabel: "جديد",
    excoinoTrader: "سوق Excoino",
    market: "سوق",
    tradeCurrenciesWithExcoino: "سوق Excoino، سوق تداول العملات الرقمية المتقدم"
  },
  transactionsCard: {
    lastTransactions: "آخر المعاملات",
    didNoneTransactions: "لم تقم بأي معاملات"
  },
  ticketsCard: {
    lastTickets: "آخر الرسائل",
    noMessages: "ليس لديك رسائل"
  },
  currenciesCard: {
    lastListedCryptos: "آخر العملات المشفرة المدرجة",
    lastAddedCryptos: "أحدث العملات المشفرة المضافة إلى Excoino."
  },
  discountCard: {
    title: "رمز الهدية",
    description: "أدخل رمز الهدية المطلوب في المربع أدناه.",
    buttonTitle: "تطبيق",
    inputPlaceholder: "رمز الهدية",
    tnxForSupportText: "شكرًا لدعمك Excoino",
    friendshipText: "هذه الصداقة تستمر",
    goToWalletText: "اذهب إلى المحفظة",
    understoodBtn: "فهمت",
    yourCodeConfirmed:
      "تم تطبيق الرمز المطلوب، تم استثمار المبلغ التالي في StakingPage.",
    priceAdded: "لتقدير دعمك لـ Excoino، تمت إضافة المبلغ التالي إلى محفظتك."
  },
  guideCard: {
    pannelGuideTitle: "دليل لوحة Excoino",
    pannelGuideText: "إذا كنت بحاجة إلى إرشادات حول استخدام لوحة Excoino"
  }
};
